(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["walkwise-product-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-av-root]').forEach(function (root) {
      /* Rotating announcement */
      (function () {
        var wrap = root.querySelector('[data-av-ann]');
        if (!wrap) return;
        var slides = Array.prototype.slice.call(wrap.querySelectorAll('[data-av-ann-slide]'));
        if (slides.length < 2) return;
        var idx = 0, timer;
        function show(i) { idx = (i + slides.length) % slides.length; slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); }); }
        function next() { show(idx + 1); }
        function prev() { show(idx - 1); }
        function start() { stop(); timer = setInterval(next, 4000); }
        function stop() { if (timer) clearInterval(timer); }
        var n = wrap.querySelector('[data-av-ann-next]'), p = wrap.querySelector('[data-av-ann-prev]');
        if (n) n.addEventListener('click', function () { next(); start(); });
        if (p) p.addEventListener('click', function () { prev(); start(); });
        start();
      })();

      /* Mobile gallery: tap a thumbnail to swap it into the hero banner */
      (function () {
        var hero = root.querySelector('[data-av-gallery-hero]');
        var rest = root.querySelector('[data-av-gallery-rest]');
        if (!hero || !rest) return;
        var mq = window.matchMedia('(max-width: 749px)');
        function swap(thumb) {
          if (!mq.matches) return;
          var heroSrc = hero.src;
          hero.src = thumb.src;
          thumb.src = heroSrc;
        }
        rest.querySelectorAll('[data-av-gallery-thumb]').forEach(function (thumb) {
          thumb.addEventListener('click', function () { swap(thumb); });
          thumb.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); swap(thumb); }
          });
        });
      })();

      /* Sticky buy box: only pin it while it actually fits on screen. Expanding a
         pack adds a colour picker per cane, which can push it past the viewport. */
      (function () {
        var box = root.querySelector('.av-buybox');
        if (!box) return;
        function update() { box.classList.toggle('is-unstuck', box.offsetHeight > window.innerHeight - 110); }
        update();
        window.addEventListener('resize', update);
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(box);
      })();

      /* ---- Shared offer / colour state -------------------------------- */

      function selectedOffer() {
        return root.querySelector('[data-av-offer].is-selected') || root.querySelector('[data-av-offer]');
      }

      /* A pack maps to its own variant only when the merchant configured one;
         otherwise the pack is N units of whatever colours the shopper picked. */
      function isPackVariant(offer) {
        return offer.getAttribute('data-qty') === '1'
          && (parseInt(offer.getAttribute('data-units'), 10) || 1) > 1
          && !!offer.getAttribute('data-variant');
      }

      /* Cart line items for the current selection, or null when no product is set. */
      function buildItems() {
        var offer = selectedOffer();
        if (!offer) return null;
        var units = parseInt(offer.getAttribute('data-units'), 10) || 1;
        var packVariant = offer.getAttribute('data-variant');
        var sels = Array.prototype.slice.call(offer.querySelectorAll('[data-av-colorsel]'));

        if (isPackVariant(offer)) {
          /* One pack line item; the chosen colours ride along as properties. */
          var props = {};
          sels.forEach(function (s) { props['Cane ' + s.getAttribute('data-slot') + ' color'] = s.getAttribute('data-name') || ''; });
          var packItem = { id: packVariant, quantity: 1 };
          if (sels.length) packItem.properties = props;
          return [packItem];
        }

        /* One line item per chosen colour, merging canes of the same colour. */
        var counts = {}, order = [];
        sels.forEach(function (s) {
          var id = s.getAttribute('data-value');
          if (!id) return;
          if (!counts[id]) { counts[id] = 0; order.push(id); }
          counts[id] += 1;
        });
        if (!order.length) {
          return packVariant ? [{ id: packVariant, quantity: units }] : null;
        }
        return order.map(function (id) { return { id: id, quantity: counts[id] }; });
      }

      /* Keep the hidden inputs in step so the no-JS form post still works. */
      function syncForms() {
        var offer = selectedOffer();
        if (!offer) return;
        var price = offer.getAttribute('data-price');
        var was = offer.getAttribute('data-was');
        var qty = offer.getAttribute('data-qty');
        var first = offer.querySelector('[data-av-colorsel]');
        var variant = isPackVariant(offer)
          ? offer.getAttribute('data-variant')
          : ((first && first.getAttribute('data-value')) || offer.getAttribute('data-variant'));

        root.querySelectorAll('[data-av-cta-price]').forEach(function (el) { if (price) el.textContent = price; });
        root.querySelectorAll('[data-av-cta-was]').forEach(function (el) { if (was) el.textContent = was; });
        root.querySelectorAll('[data-av-qty]').forEach(function (q) { if (qty) q.value = qty; });
        if (variant) root.querySelectorAll('[data-av-variant]').forEach(function (v) { v.value = variant; });
      }

      /* Offer selector */
      (function () {
        var group = root.querySelector('[data-av-offers]');
        if (!group) return;
        var offers = Array.prototype.slice.call(group.querySelectorAll('[data-av-offer]'));

        function select(offer) {
          offers.forEach(function (o) { o.classList.toggle('is-selected', o === offer); });
          var radio = offer.querySelector('.av-offer__input');
          if (radio) radio.checked = true;
          syncForms();
        }

        /* Driven by the radio so label clicks, taps and keyboard all land here once. */
        group.addEventListener('change', function (e) {
          var input = e.target.closest ? e.target.closest('.av-offer__input') : null;
          if (!input) return;
          var offer = input.closest('[data-av-offer]');
          if (offer) select(offer);
        });

        syncForms();
      })();

      /* Colour pickers (one per cane inside each pack) */
      (function () {
        var sels = Array.prototype.slice.call(root.querySelectorAll('[data-av-colorsel]'));
        if (!sels.length) return;

        function close(sel) {
          sel.classList.remove('is-open');
          var btn = sel.querySelector('.av-cs__btn'), list = sel.querySelector('.av-cs__list');
          if (btn) btn.setAttribute('aria-expanded', 'false');
          if (list) list.hidden = true;
        }
        function closeAll(except) {
          sels.forEach(function (s) { if (s !== except) close(s); });
        }

        sels.forEach(function (sel) {
          var btn = sel.querySelector('.av-cs__btn');
          var list = sel.querySelector('.av-cs__list');
          if (!btn || !list) return;
          var opts = Array.prototype.slice.call(list.querySelectorAll('.av-cs__opt'));

          btn.addEventListener('click', function (e) {
            /* Stop the click reaching the card, which would re-select the pack. */
            e.preventDefault(); e.stopPropagation();
            var wasOpen = sel.classList.contains('is-open');
            closeAll(sel);
            if (wasOpen) { close(sel); return; }
            sel.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            sel.classList.remove('is-up');
            list.style.maxHeight = '';
            list.hidden = false;

            /* The buy box is sticky, so the lower canes sit near the bottom of the
               viewport. Flip the list above the trigger when it would not fit
               below, and cap it to the room actually available either way. */
            var r = btn.getBoundingClientRect();
            var below = window.innerHeight - r.bottom - 12;
            var above = r.top - 12;
            var needed = list.scrollHeight;
            var flipUp = needed > below && above > below;
            sel.classList.toggle('is-up', flipUp);
            list.style.maxHeight = Math.max(120, Math.min(needed, flipUp ? above : below)) + 'px';
          });

          opts.forEach(function (opt) {
            opt.addEventListener('click', function (e) {
              e.preventDefault(); e.stopPropagation();
              if (opt.getAttribute('aria-disabled') === 'true') return;
              opts.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
              opt.setAttribute('aria-selected', 'true');
              sel.setAttribute('data-value', opt.getAttribute('data-value') || '');
              sel.setAttribute('data-name', opt.getAttribute('data-name') || '');
              var srcDot = opt.querySelector('.av-cs__dot');
              var trigDot = btn.querySelector('.av-cs__dot');
              if (srcDot && trigDot) trigDot.setAttribute('style', srcDot.getAttribute('style') || '');
              var lbl = btn.querySelector('.av-cs__label');
              if (lbl) lbl.textContent = opt.getAttribute('data-name') || '';
              close(sel);
              syncForms();
            });
          });

          sel.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && sel.classList.contains('is-open')) { close(sel); btn.focus(); }
          });
        });

        document.addEventListener('click', function () { closeAll(null); });
      })();

      /* Video play */
      (function () {
        var frame = root.querySelector('[data-av-video]');
        if (!frame) return;
        var vid = frame.querySelector('video'), btn = frame.querySelector('[data-av-video-play]');
        if (!vid || !btn) return;
        btn.addEventListener('click', function () { frame.classList.add('is-playing'); vid.play(); });
        vid.addEventListener('pause', function () { if (vid.currentTime === 0) frame.classList.remove('is-playing'); });
      })();

      /* Add to cart (AJAX with fallback) */
      (function () {
        var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
        var cartUrl = root.getAttribute('data-cart-url') || '/cart';
        root.querySelectorAll('[data-av-cart-form]').forEach(function (form) {
          form.addEventListener('submit', function (e) {
            /* Both forms (buybox and sticky bar) submit whatever the buybox has selected. */
            var items = buildItems();
            if (!items || !items.length) {
              e.preventDefault();
              showMsg(form, 'Select a product in the theme editor to enable add to cart.', 'error');
              return;
            }
            e.preventDefault();
            var btn = form.querySelector('[data-av-cta]');
            if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
            fetch(addUrl + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: items })
            })
              .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
              .then(function (r) {
                if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
                if (!r.ok) { showMsg(form, (r.data && r.data.description) || 'Could not add to cart.', 'error'); return; }
                showMsg(form, 'Added to cart ✓', 'success');
                root.dispatchEvent(new CustomEvent('av:cart:open', { bubbles: false }));
                window.setTimeout(function () { var m = form.querySelector('[data-av-cart-msg]'); if (m) { m.hidden = true; } }, 2500);
              })
              .catch(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } form.submit(); });
          });
        });
        function showMsg(form, text, kind) {
          var el = form.querySelector('[data-av-cart-msg]');
          if (!el) { return; }
          el.textContent = text; el.classList.remove('is-success', 'is-error');
          el.classList.add(kind === 'success' ? 'is-success' : 'is-error'); el.hidden = false;
        }
      })();

      /* Cart drawer (slide-in) */
      (function () {
        var drawer = root.querySelector('[data-av-drawer]');
        if (!drawer) return;
        var cartUrl = root.getAttribute('data-cart-url') || '/cart';
        var changeUrl = root.getAttribute('data-cart-change-url') || (cartUrl + '/change');
        var body = drawer.querySelector('[data-av-drawer-body]');
        var foot = drawer.querySelector('[data-av-drawer-foot]');
        var subtotalEl = drawer.querySelector('[data-av-drawer-subtotal]');
        var countEl = drawer.querySelector('[data-av-drawer-count]');
        var lastFocus = null;

        function money(c) { return '$' + (c / 100).toFixed(2); }
        function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

        function updateCount(n) {
          if (countEl) countEl.textContent = n ? '(' + n + ')' : '';
          root.querySelectorAll('[data-av-cart-count]').forEach(function (el) { el.textContent = n; });
        }

        function render(cart) {
          updateCount(cart.item_count);
          if (!cart.items || !cart.items.length) {
            body.innerHTML = '<div class="av-drawer__empty"><p class="av-drawer__empty-ico" aria-hidden="true">🛒</p><p>Your cart is empty.</p></div>';
            if (foot) foot.hidden = true;
            return;
          }
          var html = '';
          cart.items.forEach(function (it) {
            var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="av-ci__variant">' + esc(it.variant_title) + '</p>' : '';
            var img = it.image ? '<img class="av-ci__img" src="' + it.image + '" alt="" width="72" height="72" loading="lazy">' : '<span class="av-ci__img av-ci__img--ph" aria-hidden="true"></span>';
            html +=
              '<div class="av-ci" data-key="' + it.key + '">' +
                img +
                '<div class="av-ci__info">' +
                  '<p class="av-ci__title">' + esc(it.product_title) + '</p>' +
                  variant +
                  '<div class="av-ci__qty">' +
                    '<button type="button" class="av-ci__qbtn" data-av-qminus aria-label="Decrease quantity">−</button>' +
                    '<span class="av-ci__qval">' + it.quantity + '</span>' +
                    '<button type="button" class="av-ci__qbtn" data-av-qplus aria-label="Increase quantity">+</button>' +
                  '</div>' +
                '</div>' +
                '<div class="av-ci__right">' +
                  '<p class="av-ci__price">' + money(it.final_line_price) + '</p>' +
                  '<button type="button" class="av-ci__remove" data-av-remove>Remove</button>' +
                '</div>' +
              '</div>';
          });
          body.innerHTML = html;
          if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
          if (foot) foot.hidden = false;
        }

        function refresh() {
          body.innerHTML = '<div class="av-drawer__loading">Loading…</div>';
          fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(render)
            .catch(function () { body.innerHTML = '<div class="av-drawer__empty"><p>Could not load your cart.</p></div>'; });
        }

        function change(key, qty, rowBtn) {
          if (rowBtn) rowBtn.disabled = true;
          fetch(changeUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
          })
            .then(function (res) { return res.json(); })
            .then(render)
            .catch(function () { refresh(); });
        }

        function open() {
          lastFocus = document.activeElement;
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          refresh();
          var closeBtn = drawer.querySelector('.av-drawer__close');
          if (closeBtn) closeBtn.focus();
        }
        function close() {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          if (lastFocus && lastFocus.focus) lastFocus.focus();
        }

        /* Item interactions (event delegation) */
        body.addEventListener('click', function (e) {
          var row = e.target.closest('.av-ci');
          if (!row) return;
          var key = row.getAttribute('data-key');
          var qtyEl = row.querySelector('.av-ci__qval');
          var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
          if (e.target.closest('[data-av-remove]')) { change(key, 0, e.target); }
          else if (e.target.closest('[data-av-qplus]')) { change(key, qty + 1, e.target); }
          else if (e.target.closest('[data-av-qminus]')) { change(key, Math.max(0, qty - 1), e.target); }
        });

        /* Open / close wiring */
        root.addEventListener('av:cart:open', open);
        drawer.querySelectorAll('[data-av-drawer-close]').forEach(function (el) { el.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
        });

        /* Header cart icon opens the drawer instead of navigating */
        var cartLink = root.querySelector('.av-cart-link');
        if (cartLink) { cartLink.addEventListener('click', function (e) { e.preventDefault(); open(); }); }

        /* Reflect current count on page load */
        fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { updateCount(c.item_count); })
          .catch(function () {});
      })();

      /* Reviews: write a review + show more */
      (function () {
        var section = root.querySelector('[data-av-reviews]');
        if (!section) return;
        var grid = section.querySelector('[data-av-reviews-grid]');
        var toggle = section.querySelector('[data-av-write-toggle]');
        var form = section.querySelector('[data-av-review-form]');
        var moreBtn = section.querySelector('[data-av-more]');
        var countEls = section.querySelectorAll('[data-av-review-count]');
        var msgEl = section.querySelector('[data-av-review-msg]');
        var key = 'av_reviews_' + (section.getAttribute('data-av-reviews') || 'default');
        var BATCH = 3;

        /* Toggle the write-a-review form */
        if (toggle && form) {
          toggle.addEventListener('click', function () {
            var isHidden = form.hasAttribute('hidden');
            if (isHidden) {
              form.removeAttribute('hidden');
              toggle.setAttribute('aria-expanded', 'true');
              var first = form.querySelector('input, textarea');
              if (first) first.focus();
            } else {
              form.setAttribute('hidden', '');
              toggle.setAttribute('aria-expanded', 'false');
            }
          });
        }

        /* Star rating input */
        var rating = 0;
        var rateWrap = section.querySelector('[data-av-rate]');
        var stars = rateWrap ? Array.prototype.slice.call(rateWrap.querySelectorAll('.av-rate__star')) : [];
        function paint(n) { stars.forEach(function (s, i) { s.classList.toggle('is-on', i < n); }); }
        if (rateWrap) {
          stars.forEach(function (s) {
            var v = parseInt(s.getAttribute('data-val'), 10);
            s.addEventListener('mouseenter', function () { paint(v); });
            s.addEventListener('click', function () { rating = v; paint(v); });
          });
          rateWrap.addEventListener('mouseleave', function () { paint(rating); });
        }

        function esc(str) { var d = document.createElement('div'); d.textContent = str == null ? '' : str; return d.innerHTML; }
        function todayFr() {
          var d = new Date();
          function p(n) { return (n < 10 ? '0' : '') + n; }
          var mo = ['January','February','March','April','May','June','July','August','September','October','November','December'];
          return mo[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
        }
        function makeCard(r) {
          var pct = Math.max(0, Math.min(100, Math.round((r.rating / 5) * 100)));
          var fig = document.createElement('figure');
          fig.className = 'av-review av-review--user';
          var imgHtml = r.photo ? '<img class="av-review__img" src="' + esc(r.photo) + '" alt="" loading="lazy">' : '';
          fig.innerHTML =
            imgHtml +
            '<div class="av-review__body">' +
            '<figcaption class="av-review__name"><span class="av-review__name-text">' + esc(r.name) + '</span> <span class="av-review__badge">✔ Posted by you</span></figcaption>' +
            '<time class="av-review__date">' + esc(r.date) + '</time>' +
            '<div class="av-stars" aria-hidden="true" style="--pct:' + pct + '%;">★★★★★</div>' +
            '<blockquote>« ' + esc(r.content) + ' »</blockquote>' +
            '</div>';
          return fig;
        }

        /* Photo upload: read + downscale to keep localStorage small */
        var photoDataUrl = '';
        var photoInput = form ? form.querySelector('[data-av-photo-input]') : null;
        var photoPreview = form ? form.querySelector('[data-av-photo-preview]') : null;
        var photoPreviewImg = photoPreview ? photoPreview.querySelector('img') : null;
        var photoRemoveBtn = form ? form.querySelector('[data-av-photo-remove]') : null;
        function resetPhoto() {
          photoDataUrl = '';
          if (photoInput) photoInput.value = '';
          if (photoPreview) photoPreview.hidden = true;
        }
        if (photoInput) {
          photoInput.addEventListener('change', function () {
            var file = photoInput.files && photoInput.files[0];
            if (!file) return;
            var reader = new FileReader();
            reader.onload = function (e) {
              var img = new Image();
              img.onload = function () {
                var maxDim = 800;
                var scale = Math.min(1, maxDim / Math.max(img.width, img.height));
                var w = Math.round(img.width * scale);
                var h = Math.round(img.height * scale);
                var canvas = document.createElement('canvas');
                canvas.width = w;
                canvas.height = h;
                canvas.getContext('2d').drawImage(img, 0, 0, w, h);
                photoDataUrl = canvas.toDataURL('image/jpeg', 0.82);
                if (photoPreviewImg) photoPreviewImg.src = photoDataUrl;
                if (photoPreview) photoPreview.hidden = false;
              };
              img.src = e.target.result;
            };
            reader.readAsDataURL(file);
          });
        }
        if (photoRemoveBtn) {
          photoRemoveBtn.addEventListener('click', resetPhoto);
        }
        function showMsg(text, kind) {
          if (!msgEl) return;
          msgEl.textContent = text;
          msgEl.classList.remove('is-success', 'is-error');
          msgEl.classList.add(kind === 'success' ? 'is-success' : 'is-error');
          msgEl.hidden = false;
        }

        /* Restore previously submitted reviews */
        var saved = [];
        try { saved = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { saved = []; }
        if (grid && saved.length) {
          saved.forEach(function (r) { grid.insertBefore(makeCard(r), grid.firstChild); });
          countEls.forEach(function (el) {
            var n = parseInt((el.textContent || '').replace(/\D/g, ''), 10) || 0;
            el.textContent = n + saved.length;
          });
        }

        /* Submit a new review */
        if (form && grid) {
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            var name = (form.querySelector('[name="name"]').value || '').trim();
            var content = (form.querySelector('[name="content"]').value || '').trim();
            if (!rating) { showMsg('Please select a rating.', 'error'); return; }
            if (!name || !content) { showMsg('Please enter your name and review.', 'error'); return; }
            var review = { name: name, content: content, rating: rating, date: todayFr(), photo: photoDataUrl };
            grid.insertBefore(makeCard(review), grid.firstChild);
            saved.unshift(review);
            try { localStorage.setItem(key, JSON.stringify(saved)); } catch (e) {}
            countEls.forEach(function (el) {
              var n = parseInt((el.textContent || '').replace(/\D/g, ''), 10) || 0;
              el.textContent = n + 1;
            });
            form.reset();
            rating = 0;
            paint(0);
            resetPhoto();
            showMsg('Thank you! Your review has been published.', 'success');
          });
        }

        /* See more reviews */
        if (moreBtn && grid) {
          moreBtn.addEventListener('click', function () {
            var extras = Array.prototype.slice.call(grid.querySelectorAll('.av-review--extra.is-collapsed'));
            extras.slice(0, BATCH).forEach(function (el) { el.classList.remove('is-collapsed'); });
            if (grid.querySelectorAll('.av-review--extra.is-collapsed').length === 0) {
              moreBtn.hidden = true;
            }
          });
          if (grid.querySelectorAll('.av-review--extra.is-collapsed').length === 0) {
            moreBtn.hidden = true;
          }
        }
      })();

      /* Sticky bar — visible once the main CTA is scrolled past, hidden again over the footer */
      (function () {
        var bar = root.querySelector('[data-av-sticky]');
        var anchor = root.querySelector('.av-buybox .av-cta');
        var footer = root.querySelector('.av-footer');
        if (!bar || !anchor || !('IntersectionObserver' in window)) return;

        var pastAnchor = false; /* main CTA has scrolled off the top */
        var atFooter = false;   /* footer has come into view */

        function update() { bar.hidden = !pastAnchor || atFooter; }

        /* Default viewport root: a zero-height root (rootMargin -100%) never flips
           isIntersecting, so the callback would only ever fire once on init. */
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            /* Past it only once it has left upwards, not while still below the fold */
            pastAnchor = !en.isIntersecting && en.boundingClientRect.bottom < 0;
          });
          update();
        }).observe(anchor);

        if (footer) {
          /* Fires both ways, so scrolling back up out of the footer restores the bar */
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { atFooter = en.isIntersecting; });
            update();
          }).observe(footer);
        }
      })();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
